export const Role = {
    Admin: 'ROLE_ADMIN',
    Staff: 'ROLE_STAFF',
    FrontDesk: 'ROLE_FRONTDESK',
    Admin2: 'ROLE_ADMIN2',
    Staff2: 'ROLE_STAFF2',
    FrontDesk2: 'ROLE_FRONTDESK2',
    // 主管。自動簡訊的設定、範本啟用、人工補發都限這個角色以上。
    Supervisor: 'ROLE_SUPERVISOR',
}
